// extracted by mini-css-extract-plugin
export default {"goal_modal":"styles_goal_modal__YRb9y","content":"styles_content__ijD-p","cardfade":"styles_cardfade__wKoMa"};